import storyCard from './story-card/story-card.vue';
// import Swiper core and required modules
import { Navigation, Pagination, Lazy, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import spotify from './spotify.vue';
import g4gBlock from '../g4g/g4g-block.vue';
import instagram from './socialFeed/instagram.vue';
import { SpotifyPlacement } from '../enums/strapi';
import loadingAnimation from '../loading-animation.vue';

export default {
  name: 'commonThread',
  components: {
    storyCard,
    spotify,
    g4gBlock,
    Swiper,
    SwiperSlide,
    loadingAnimation,
    instagram,
  },
  data() {
    return {
      ambassadors: [],
      loading: true,
      searchQuery: '',
      selectedCategory: '',
      showSection: false,
      SpotifyPlacement,
      spotifyPlacement: '',
      spotifyLink: '',
      spotifyImg: '',
      spotifyDesc: '',
      spotifyTitle: '',
      storiesHeader: '',
      stories: [],
      videos: [],
      active_el: 0,
    };
  },
  methods: {
    toggle() {
      this.showSection = !this.showSection;
    },
    formatDateString(dateString) {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
    activate: function (el) {
      this.active_el = el;
    },

    updateContentByCategory(category) {
      //set selected cateogry so we can add it to url when navigating to archive page and need to prefilter
      this.selectedCategory = category;
      //stories by category
      axios
        //strapi endpoint & query params explained: gets stories
        //populate[category]=* : includes story's catgegory
        //&pagination[limit]=3 : limits to 3 stories
        //populate[heroMedia][populate][0]=heroPhoto : populates hero media data
        //sort=posted_date:desc : sorts by newest published date
        //filters[ghostPublish][$eq]=false : only returns stories where ghost publish is set to false
        //filters[storyType]=story : only returns stories (does not return videos)
        //filters[category][categoryName][$eq]=${category} : only returns stoires with the category the user selected
        .get(
          `https://cms.cotopaxi.com/api/stories?populate[category]=*&pagination[limit]=3&populate[heroMedia][populate][0]=heroPhoto&sort=posted_date:desc&filters[ghostPublish][$eq]=false&filters[storyType]=story&filters[category][categoryName][$eq]=${category}`
        )
        .then((res) => {
          this.stories = res.data.data;
        })
        .catch((err) => {
          this.error = true;
        });

      //videos
      axios
        //same query param explaination as above but this one returns videos instead of stories
        //filters[storyType]=video : only returns story type of video
        .get(
          `https://cms.cotopaxi.com/api/stories?populate[category]=*&pagination[limit]=3&populate[heroMedia][populate][0]=heroPhoto&sort=posted_date:desc&filters[ghostPublish][$eq]=false&filters[storyType]=video&filters[category][categoryName][$eq]=${category}`
        )
        .then((res) => {
          this.videos = res.data.data;
        })
        .catch((err) => {
          this.error = true;
        });
    },

    searchArchives(query) {
      //using search bar on landing page will redirect you to the archive page and carry over search term and catoegory selected
      if (this.selectedCategory) {
        window.location.href = `/pages/common-thread-archive?search=${query}&category=${this.selectedCategory}`;
      } else {
        window.location.href = `/pages/common-thread-archive?search=${query}`;
      }
    },

    truncateAmbassadorDesc(ambassadors) {
      ambassadors.forEach((ambass) => {
        if (ambass.attributes.body.length > 264) {
          let ambassBodyTruncated = ambass.attributes.body.substring(0, 264);
          ambass.attributes.bodyTruncated = ambassBodyTruncated + '...</p>';
        }
      });
    },
  },
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, A11y],
    };
  },
  mounted() {
    //this makes all the api calls and waits for all of the responses to be returned before setting our data variables
    const storiesData = axios.get(
      `https://cms.cotopaxi.com/api/stories?populate[category]=*&pagination[limit]=3&populate[heroMedia][populate][0]=heroPhoto&sort=posted_date:desc&filters[ghostPublish][$eq]=false&filters[storyType]=story`
    );
    const videoData = axios.get(
      `https://cms.cotopaxi.com/api/stories?populate[category]=*&pagination[limit]=3&populate[heroMedia][populate][0]=heroPhoto&sort=posted_date:desc&filters[ghostPublish][$eq]=false&filters[storyType]=video`
    );
    const landingPageData = axios.get(
      `https://cms.cotopaxi.com/api/landing-page?populate=*`
    );
    const ambassadorsData = axios.get(
      `https://cms.cotopaxi.com/api/ambassadors?populate=*`
    );

    Promise.all([storiesData, videoData, landingPageData, ambassadorsData])
      .then(
        ([
          storiesDataResp,
          videoDataResp,
          landingPageDataResp,
          ambassadorsDataResp,
        ]) => {
          //story content
          this.stories = storiesDataResp.data.data;
          this.videos = videoDataResp.data.data;
          //ambassador details
          this.ambassadors = ambassadorsDataResp.data.data;
          this.truncateAmbassadorDesc(this.ambassadors);
          //spotify details
          this.spotifyPlacement =
            landingPageDataResp.data.data.attributes.spotifyPlacement;
          this.spotifyLink =
            landingPageDataResp.data.data.attributes.spotifyPlaylistLink;
          if (landingPageDataResp.data.data.attributes.spotifyImage.data) {
            this.spotifyImg =
              landingPageDataResp.data.data.attributes.spotifyImage.data.attributes.url;
          }
          this.spotifyDesc =
            landingPageDataResp.data.data.attributes.spotifyDescription;
          this.spotifyTitle =
            landingPageDataResp.data.data.attributes.spotifyTitle;
          //landing page details
          this.landingpage = landingPageDataResp.data.data.attributes;
          this.storiesHeader =
            landingPageDataResp.data.data.attributes.storiesHeader;

          this.loading = false;
        }
      )
      .catch((err) => {
        console.error(err);
      });
  },
};
